// @flow

import React from 'react'

export type PropTypes = {
  text: string,
}

export default (props: PropTypes) => (
  <span className="mod-tooltip mod-evaluate__help-tooltip">
    <span className="baloon baloon-top user-detail-baloon mod-tooltip__detail mod-evaluate__help-baloon">
      <span className="baloon-inner">{props.text}</span>
    </span>
  </span>
)



// WEBPACK FOOTER //
// ./src/components/molecules/room/HelpTooltip/index.jsx